import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;

function AdminOperations() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/admin/operations`, { headers: { token: localStorage.getItem("token") } });
      setData(response.data); setError("");
    } catch (requestError) { setError(requestError.response?.data?.message || "Driftstatus kunde inte hämtas"); }
  }, []);
  useEffect(() => { load(); }, [load]);

  return <div className="mx-auto w-full max-w-5xl px-4 py-4"><div className="theme-card">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div><p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">Administration</p><h1 className="mt-2 text-lg font-bold text-slate-800">Driftöversikt</h1></div>
      <div className="flex gap-2"><button className="theme-button-secondary px-4 py-2 text-sm" onClick={load}>Uppdatera</button><button className="theme-button-secondary px-4 py-2 text-sm" onClick={() => navigate("/admin-dashboard")}>Tillbaka</button></div>
    </div>
    {error && <div className="theme-alert-error mt-4">{error}</div>}
    {!data && !error && <div className="theme-empty-state mt-4">Kontrollerar tjänster…</div>}
    {data && <>
      <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {Object.entries(data.services).map(([key, service]) => <div key={key} className={`p-4 ${service.ok ? "theme-alert-success" : "theme-alert-error"}`}>
          <p className="text-xs font-bold uppercase tracking-wide">{key}</p><p className="mt-2 text-sm">{service.message}</p>
        </div>)}
      </div>
      <div className="mt-5 grid gap-4 lg:grid-cols-3">
        <section className="theme-panel"><h2 className="font-semibold text-slate-800">E-postkö och fel</h2><dl className="mt-3 space-y-1 text-sm text-slate-600"><div>Väntar: {data.email.counts.pending}</div><div>Retry: {data.email.counts.retry}</div><div>Misslyckade: {data.email.counts.failed}</div><div>Fel/bounce/complaint senaste dygnet: {data.email.errorCount24h}</div><div>Configuration set: {data.email.configurationSetConfigured ? "konfigurerat" : "saknas"}</div></dl></section>
        <section className="theme-panel"><h2 className="font-semibold text-slate-800">Omfattning</h2><p className="mt-3 text-sm text-slate-600">{data.totals.users} användare</p><p className="text-sm text-slate-600">{data.totals.groups} grupper</p></section>
        <section className="theme-panel"><h2 className="font-semibold text-slate-800">Senaste backup</h2>{data.backup ? <><p className="mt-3 break-all text-sm text-slate-600">{data.backup.fileName}</p><p className="text-sm text-slate-600">{new Date(data.backup.createdAt).toLocaleString("sv-SE")}</p></> : <p className="mt-3 text-sm text-amber-700">Ingen backupfil hittades.</p>}</section>
      </div>
      <p className="mt-4 text-xs text-slate-500">Kontrollerat {new Date(data.checkedAt).toLocaleString("sv-SE")}</p>
    </>}
  </div></div>;
}

export default AdminOperations;
